<template>
	<div>
		<core-alert v-if="activeContent.error" type="error">
			<div v-html="activeContent.error"></div>
		</core-alert>
		<core-alert v-if="activeContent.message" type="info">
			<div v-html="activeContent.message"></div>
		</core-alert>
	</div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('integrations')

export default {
	computed : {
		...mapState([ 'activeContent' ]),
	},
}
</script>
